import React, { useEffect, useState } from 'react';

import classNames from 'classnames/bind';
import style from './ToastPopup.module.scss';

const cx = classNames.bind(style);
export default function ToastPopup(props) {
  const [show, setShow] = useState(false);
  const { location } = props;

  useEffect(() => {
    if (show === true)
      setTimeout(
        () => {
          setShow(false);
          props.close();
        },
        props?.showSecond ? props?.showSecond * 1000 : 2000,
      );
  }, [show]);

  useEffect(() => {
    setShow(props.open);
  }, [props.open]);

  return (
    <div
      className={cx(
        'toast-popup-wrapper',
        show && 'toast-popup-wrapper-show',
        location ? `toast-popup-wrapper-${location}` : 'toast-popup-wrapper-bottom',
      )}
    >
      <div className={cx('toast-popup-container')}>
        <div className={cx('toast-title')}>{props.title}</div>
        {props.description && <div className={cx('toast-description')}>{props.description}</div>}
      </div>
    </div>
  );
}
